module.exports = __webpack_public_path__ + "static/img/linda_desperate.e939401.png";